import type { IHttpClient } from '@/application/ports';
import type {
  VisitaDTO
} from '@/application/dto/visitas/VisitaDTO';
import type { CreateVisitaDTO } from '@/application/dto/visitas/CreateVisitaDTO';
import type { UpdateVisitaDTO } from '@/application/dto/visitas/UpdateVisita';
import type { Visita } from '@/domain/entities/visitas';
import type { IVisitaRepository } from '@/domain/repositories/IVisitaRepository';
import { API_ENDPOINTS } from '@/infrastructure/config/api.config';

export class VisitaRepository implements IVisitaRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  async findAll(): Promise<Visita[]> {
    const response = await this.httpClient.get<VisitaDTO[]>(
      API_ENDPOINTS.visitas.base
    );
    return response.data.map(dto => this.mapToEntity(dto));
  }

  async findById(id: string): Promise<Visita> {
    const response = await this.httpClient.get<VisitaDTO>(
      API_ENDPOINTS.visitas.byId(id)
    );
    return this.mapToEntity({ ...response.data, id: Number(id) });
  }

  async create(data: CreateVisitaDTO): Promise<Visita> {
    const response = await this.httpClient.post<VisitaDTO>(
      API_ENDPOINTS.visitas.base,
      data
    );
    return this.mapToEntity(response.data);
  }

  async updateFecha(id: string, data: UpdateVisitaDTO): Promise<Visita> {
    const response = await this.httpClient.patch<VisitaDTO>(
      API_ENDPOINTS.visitas.byId(id),
      data
    );
    return this.mapToEntity({ ...response.data, id: Number(id) });
  }

  private mapToEntity(dto: VisitaDTO): Visita {
    return {
      id: dto.id,
      fecha: dto.fecha,
      ubicacion_generica: dto.ubicacion_generica
    };
  }
}
